import React from "react";
import { Button, Tag, Icon, Modal, Select, notification, Divider } from "antd";
import api from "../../../../../../../services/api";

import "./styles.css";
import CurrencyField from "../../../../../../../components/CurrencyField";
import { format } from "../../../../../../../utils/MoneyFormater";

export function ValorHO({ valor, idParcela, data }) {
  const [isEditing, setEditing] = React.useState(false);
  const [isSaving, setSaving] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState(valor);
  const [value, setValue] = React.useState(valor);

  const toggleEditing = () => setEditing(!isEditing);

  const STATUS_PARCELA_PAGO = "1";
  const canEdit = data.status_parcela === STATUS_PARCELA_PAGO;

  const handleSave = () => {
    setSaving(true);

    api
      .put(`/acordo/parcela/${idParcela}/`, {
        valor_ho_contratual: selectedValue,
        data_vencimento: data.data_vencimento,
        num_parcela: data.num_parcela
      })
      .then(() => {
        toggleEditing();

        notification.success({
          message: "Valor HO atualizado com sucesso."
        });

        setValue(selectedValue);
      })
      .catch(() => {
        notification.error({
          message: "Ocorreu um erro ao atualizar o valor."
        });
      })
      .finally(() => {
        setSaving(false);
      });
  };

  return (
    <React.Fragment>
      <div className="valorho__wrapper">
        <span>R$ {format(value)}</span>
        {canEdit && (
          <React.Fragment>
            <Divider type="vertical" />
            <Button type="primary" ghost size="small" onClick={toggleEditing}>
              <Icon type="edit" />
            </Button>
          </React.Fragment>
        )}
      </div>
      <Modal
        visible={isEditing}
        title="Alterar valor HO"
        okText="Salvar"
        cancelText="Cancelar"
        onCancel={toggleEditing}
        confirmLoading={isSaving}
        onOk={handleSave}
        cancelButtonProps={{
          disabled: isSaving
        }}
      >
        <div>
          <label for="value">Insira o valor:</label>
          <div style={{ marginTop: "5px" }}>
            {isEditing && (
              <CurrencyField
                className="ant-input"
                name="valor_pago"
                onChangeEvent={setSelectedValue}
                innitialValue={value}
                value={selectedValue}
              />
            )}
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Acordo/View/AcordoView/AcordoParcelas/Parcela/ValorHO/index.jsx